import { jsx as t, Fragment as ie, jsxs as p } from "react/jsx-runtime";
import b, { useState as f, useEffect as B, useRef as se } from "react";
import { _ as R, i as E, a as $ } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import r from "styled-components";
import { RangoButtonMini as le } from "./ButtonMini.js";
import { a as H, R as V, I as de } from "../chunks/index.cff5baaf.js";
import { a as ce, R as pe, B as me } from "../chunks/index.b09c00db.js";
import { D as ue, R as L } from "../chunks/Description.be3b00d1.js";
import { RangoImage as ge } from "./Image.js";
import { T as _, R as fe } from "../chunks/index.1a4ab965.js";
import { s as ve } from "../chunks/vendor.6ce6056b.js";
const he = r.div.withConfig({
  displayName: "Container",
  componentId: "sc-12xyqh9-0"
})(["display:flex;width:100%;flex-direction:column;gap:var(--spacing-2x);"]), ye = r.label.withConfig({
  displayName: "Label",
  componentId: "sc-12xyqh9-1"
})(["", " color:var(--text-label-color);z-index:-11;"], R), xe = r.span.withConfig({
  displayName: "SupportText",
  componentId: "sc-12xyqh9-2"
})(["color:var(--text-support-text-color);", ""], E), Ce = r.input.withConfig({
  displayName: "InputFile",
  componentId: "sc-12xyqh9-3"
})(["display:none;"]), we = r.div.withConfig({
  displayName: "Upload",
  componentId: "sc-12xyqh9-4"
})(["", ";cursor:pointer;display:flex;height:200px;flex-direction:column;justify-content:center;width:100%;align-items:center;border-radius:var(--border-radius-md);border:dashed var(--default-border-width) var(--elements-border-color);border:", ";gap:var(--spacing-4x);&:hover{", " border-color:transparent;}"], ({
  $isDragOver: o
}) => o && `${$}`, ({
  $isOpen: o,
  $isDragOver: u
}) => (o || u) && "solid var(--default-border-width) var(--active-border-color);", $), Ie = r.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-12xyqh9-5"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:var(--spacing-2x);"]);
r.div.withConfig({
  displayName: "CompleteContainer",
  componentId: "sc-12xyqh9-6"
})(["display:flex;flex-direction:row;align-items:center;height:var(--size-9x);width:312px;padding:0px var(--spacing-2x);gap:var(--spacing-2x);border-radius:var(--default-border-radius);border:solid var(--elements-border-color);"]);
r.div.withConfig({
  displayName: "CompleteText",
  componentId: "sc-12xyqh9-7"
})(["display:flex;flex-direction:column;gap:var(--spacing-half);"]);
r.span.withConfig({
  displayName: "CompleteLabel",
  componentId: "sc-12xyqh9-8"
})(["", ""], R);
const be = r(le).withConfig({
  displayName: "SelectFileButton",
  componentId: "sc-12xyqh9-9"
})(["&:hover{& > span::after{background-color:transparent !important;}}"]), j = r.div.withConfig({
  displayName: "CompleteContainer",
  componentId: "sc-qkkdwe-0"
})(["display:flex;justify-content:", ";flex-direction:row;align-items:center;height:var(--size-9x);padding-left:var(--spacing-2x);padding-right:var(--spacing-half);gap:var(--spacing-2x);border-radius:var(--default-border-radius);border:solid var(--default-border-width) ", ";", "{", "{", ";}}"], ({
  status: o
}) => o === "uploading" ? "" : "space-between", ({
  hasError: o
}) => o ? "var(--negative-border-color)" : "var(--elements-border-color)", ce, H, ({
  hasError: o
}) => o && "color: var(--negative-icon-color)"), Ne = r.div.withConfig({
  displayName: "Content",
  componentId: "sc-qkkdwe-1"
})(["display:flex;flex-direction:row;align-items:center;gap:var(--spacing-2x);", "{", ";}"], H, ({
  hasError: o
}) => o && "color: var(--negative-border-color)"), qe = r(ge).withConfig({
  displayName: "PreviewImage",
  componentId: "sc-qkkdwe-2"
})(["width:var(--size-5x);height:var(--size-5x);"]), M = r.div.withConfig({
  displayName: "CompleteText",
  componentId: "sc-qkkdwe-3"
})(["display:flex;flex-direction:column;gap:var(--spacing-half);", "{", ";}"], ue, ({
  hasError: o
}) => o && "color: var(--negative-description-color)"), P = r.span.withConfig({
  displayName: "CompleteLabel",
  componentId: "sc-qkkdwe-4"
})(["", " ", ";"], R, ({
  hasError: o
}) => o ? "color: var(--negative-label-color)" : "color: var(--text-label-color)"), ke = r.div.withConfig({
  displayName: "FileContainer",
  componentId: "sc-qkkdwe-5"
})(["display:flex;flex-direction:column;gap:var(--spacing-1x);"]), Te = r.span.withConfig({
  displayName: "SupportText",
  componentId: "sc-qkkdwe-6"
})(["", " color:var(--negative-label-color);"], E), m = {
  Uploading: "uploading",
  Complete: "complete",
  Error: "error"
}, G = b.forwardRef(({
  onRemove: o,
  onFileUpload: u,
  fileSize: v,
  label: h,
  supportText: N,
  supportedFiles: q,
  hasError: i,
  file: c
}, g) => {
  const [d, s] = f(m.Uploading), I = v / 1024 / 1024;
  return B(() => {
    (d === m.Complete || d === m.Error) && u && u(c, d);
  }, [d]), B(() => {
    const y = !q.includes(c.type) || !c.type, x = setTimeout(() => {
      I > 5 || y ? (console.error("filesize", c), s(m.Error)) : s(m.Complete);
    }, 1e3);
    return () => clearTimeout(x);
  }, []), /* @__PURE__ */ t(ie, { children: d === "uploading" ? /* @__PURE__ */ t(j, { hasError: i, status: d, children: /* @__PURE__ */ p(M, { status: d, children: [
    /* @__PURE__ */ t(P, { "data-testid": "rango-uploader-file-label", status: d, children: h }),
    /* @__PURE__ */ t(L, { children: "Uploading..." })
  ] }) }) : /* @__PURE__ */ p(ke, { children: [
    /* @__PURE__ */ p(j, { hasError: i, status: d, children: [
      /* @__PURE__ */ p(Ne, { hasError: i, children: [
        c.type.includes("image") ? /* @__PURE__ */ t(qe, { src: URL.createObjectURL(c), alt: h }) : /* @__PURE__ */ t(V, { icon: i ? "NegativeLine" : "FileLine" }),
        /* @__PURE__ */ p(M, { hasError: i, children: [
          /* @__PURE__ */ t(P, { "data-testid": `rango-uploader-file-label${i ? "-error" : ""}`, hasError: i, children: h }),
          /* @__PURE__ */ t(L, { children: I.toFixed(2) + " MB" })
        ] })
      ] }),
      /* @__PURE__ */ t(pe, { icon: "DeleteLine", onClick: o, size: me.LG })
    ] }),
    i && /* @__PURE__ */ t(Te, { children: N })
  ] }) });
});
G.displayName = "UploaderComplete";
const De = b.forwardRef(({
  label: o,
  supportText: u,
  onChange: v,
  onRemove: h,
  buttonLabel: N,
  description: q,
  acceptFiles: i,
  toastTimeout: c,
  filesWithError: g
}, d) => {
  const s = se(), [I, y] = f(!1), [x, Y] = f(), [Z, F] = f(!1), [J, C] = f(!1), [k, T] = f([]), [K, U] = f([]);
  b.useEffect(() => {
    if (x) {
      const e = Array.from(x).filter((a) => !w(a));
      v && v(e), T((a) => [...Array.from(a), ...Array.from(e)]);
      const n = Array.from(x).map((a) => A(a));
      S(n);
    }
  }, [x]), b.useEffect(() => (s.current.addEventListener("cancel", () => C(!1)), () => {
    var e;
    return (e = s == null ? void 0 : s.current) == null ? void 0 : e.removeEventListener("cancel", () => C(!1));
  }), []);
  const Q = (e) => {
    e.preventDefault(), C(!1), y(!0);
  }, X = (e) => {
    e.preventDefault(), y(!1);
  }, O = (e) => {
    e.preventDefault(), y(!0);
  }, W = (e) => {
    e.preventDefault(), Y(e.dataTransfer.files), y(!1);
  }, ee = () => {
    v && v(s.current.files), T((e) => [...Array.from(e), ...Array.from(s.current.files)]), C(!1);
  }, z = (e) => {
    e.stopPropagation(), C(!0), s.current.value = "", s.current.click();
  }, oe = (e) => {
    const n = Array.from(k).find((a, l) => l === e);
    T(Array.from(k).filter((a, l) => l !== e)), h && h(n);
  }, w = (e) => e.size / 1024 / 1024 > 5 || !i.includes(e.type) || !e.type, te = (e) => {
    Z && (S([A(e)]), F(!1));
  }, S = (e) => {
    U((n) => [...n, ...e]);
  }, re = (e, n) => {
    const a = () => {
      U((l) => l.map((D) => D.file === e ? {
        ...D,
        opened: !1
      } : D));
    };
    n && c ? setTimeout(() => {
      a();
    }, c) : n || a();
  }, A = (e) => ({
    file: e,
    opened: !0,
    id: `${e.name} - ${w(e)}`,
    type: w(e) ? _.Negative : _.Positive,
    children: w(e) ? ae(e, w(e) ? m.Error : m.Complete) : ne(e),
    onOpen: (n) => re(e, n)
  }), ae = (e, n) => {
    const a = e.name.split(".").shift().slice(0, 10), l = e.name.split(".").pop();
    if (n === m.Error && (!i.includes(e.type) || e.type === ""))
      return `O arquivo (${a}...).${l} não pode ser carregado. Verifique se o formato do arquivo é compatível.`;
    if (e.size / 1024 / 1024 > 5)
      return `O arquivo (${a}...).${l} não pode ser carregado. Verifique se o tamanho do arquivo não excede o limite permitido.`;
  }, ne = (e) => `O Arquivo ${e.name} foi carregado com sucesso.`;
  return /* @__PURE__ */ p(he, { ref: d, "data-testid": "rango-uploader", "data-rango-component": "rango-uploader", "data-is-rango": !0, children: [
    /* @__PURE__ */ t(ye, { "data-testid": "rango-uploader-label", children: o }),
    /* @__PURE__ */ p(we, { onDragEnter: Q, onDragOver: O, onDragLeave: X, onDrop: W, onChange: () => F(!0), onDragEnterCapture: O, onClick: z, $isDragOver: I, $isOpen: J, "data-testid": "rango-uploader-area", children: [
      /* @__PURE__ */ p(Ie, { children: [
        /* @__PURE__ */ t(V, { icon: "UploadLine", size: de.MD }),
        /* @__PURE__ */ t(L, { children: q })
      ] }),
      /* @__PURE__ */ t(be, { disableActiveClick: !0, onClick: z, children: N }),
      /* @__PURE__ */ t(Ce, { onAbort: () => C(!1), "data-testid": "rango-uploader-input", type: "file", accept: i, ref: s, onChange: ee, multiple: !0 })
    ] }),
    u && /* @__PURE__ */ t(xe, { "data-testid": "rango-uploader-support-text", children: u }),
    Array.from(k).map((e, n) => {
      var a;
      return /* @__PURE__ */ t(G, { fileSize: e.size, label: ve(e.name, 0, 20), supportedFiles: i, supportText: (a = g == null ? void 0 : g.find((l) => l.fileName === e.name)) == null ? void 0 : a.errorText, onRemove: () => oe(n), onFileUpload: te, hasError: w(e) || (g == null ? void 0 : g.some((l) => l.fileName === e.name)), file: e }, n);
    }),
    /* @__PURE__ */ t(fe, { toasters: K })
  ] });
});
De.displayName = "RangoUploader";
export {
  De as RangoUploader
};
